// extracted by mini-css-extract-plugin
export default {"payrexxButton":"PayrexxModal_payrexxButton__8o0SM"};